import React from "react";
import ReactPaginate from 'react-paginate';
import PageSizeSelect from './PageSizeSelect';

const Index = ({
    toggle,
    dataTotal,
    recordTotal,
    maxPage,
    page,
    length = 10,
    onPageSizeChange,
    disabled = false,
}) => {

    const handlePageClick = (event) => {
        if (toggle) {
            toggle(event.selected + 1)
        }

    };

    return (
        <>
            {
                recordTotal !== 0 && recordTotal !== null && (
                    <>
                        <div className="mini-show table-pagination-mobile">
                            <PageSizeSelect
                                value={length}
                                onChange={onPageSizeChange}
                                disabled={disabled}
                            />
                            <p style={{ margin: 0, fontSize: 14 }}>{`Menampilkan ${dataTotal ?? 0} dari ${recordTotal ?? 0}`}</p>
                        </div>
                        <div className="mini-show table-pagination-mobile-pages">
                            <div>
                                <ReactPaginate
                                    marginPagesDisplayed={1}
                                    previousLabel={(<span className="material-icons-round">arrow_back</span>)}
                                    previousLinkClassName={"page-link"}
                                    nextLabel={(<span className="material-icons-round">arrow_forward</span>)}
                                    nextLinkClassName={"page-link"}
                                    pageCount={maxPage}
                                    containerClassName={"pagination justify-content-end"}
                                    pageClassName={"page-item"}
                                    breakClassName={"page-item"}
                                    pageLinkClassName={"page-link"}
                                    breakLinkClassName={"page-link"}
                                    activeClassName={"active"}
                                    onPageChange={(event) => handlePageClick(event)}
                                    forceSelected={page - 1}
                                    forcePage={page - 1}
                                    initialPage={page - 1}
                                />
                            </div>
                        </div>
                        <div className="table-pagination-desktop mini-hide">
                            <div className="table-pagination-summary">
                                <PageSizeSelect
                                    value={length}
                                    onChange={onPageSizeChange}
                                    disabled={disabled}
                                />
                                <p style={{ margin: 0, fontSize: 14 }}>{`Menampilkan ${dataTotal ?? 0} dari ${recordTotal ?? 0}`}</p>
                            </div>
                            <div>
                                <ReactPaginate
                                    pageRangeDisplayed={2}
                                    marginPagesDisplayed={2}
                                    previousLabel={(<span className="material-icons-round">arrow_back</span>)}
                                    previousLinkClassName={"page-link"}
                                    nextLabel={(<span className="material-icons-round">arrow_forward</span>)}
                                    nextLinkClassName={"page-link"}
                                    pageCount={maxPage}
                                    containerClassName={"pagination justify-content-end"}
                                    pageClassName={"page-item"}
                                    breakClassName={"page-item"}
                                    pageLinkClassName={"page-link"}
                                    breakLinkClassName={"page-link"}
                                    activeClassName={"active"}
                                    onPageChange={(event) => handlePageClick(event)}
                                    forceSelected={page - 1}
                                    forcePage={page - 1}
                                    initialPage={page - 1}
                                />
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
}

export default Index
